import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-lg font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 disabled:pointer-events-none disabled:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary-hover active:bg-primary-active shadow-xs",
        destructive: "bg-destructive hover:bg-destructive-hover text-destructive-foreground shadow-xs",
        outline: "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 hover:text-slate-900 shadow-2xs",
        secondary: "bg-slate-100 text-slate-800 hover:bg-slate-200",
        ghost: "text-slate-600 hover:bg-slate-100 hover:text-slate-900",
        "ghost-destructive": "text-destructive hover:bg-destructive-muted",
        shell: "text-shell-foreground hover:bg-static-white/5 hover:text-static-white",
        link: "text-primary underline-offset-4 hover:underline",
        success: "bg-success hover:bg-success/90 text-success-foreground",
        warning: "bg-warning hover:bg-warning/90 text-warning-foreground",
      },
      size: {
        default: "h-9 px-4 text-sm gap-2",
        sm: "h-8 px-3 text-xs gap-1.5",
        lg: "h-10 px-5 text-sm gap-2",
        xl: "h-12 px-6 text-base gap-2",
        nav: "h-9 px-3 text-xs gap-2",
        stack: "h-auto min-h-12 flex-col gap-1 whitespace-normal px-1",
        icon: "h-9 w-9",
        "icon-sm": "h-8 w-8",
        "icon-lg": "h-10 w-10",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  }
);

/** variant: default|destructive|outline|secondary|ghost|ghost-destructive|shell|link|success.
 * size: default|sm|lg|xl|nav (kenar menü satırı, text-xs)|stack (ikon üstte yazı altta, mobil alt bar)|icon|icon-sm|icon-lg. asChild: Radix Slot; className son override.
 * @example <Button variant="outline" size="sm">Vazgeç</Button>
 */
const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button";
  return <Comp ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props} />;
});
Button.displayName = "Button";
export { Button, buttonVariants };
